import type { Message } from '@shared/types';

type MessageWithTreeMetadata = Message & {
  children?: unknown;
  parent?: unknown;
  siblings?: unknown;
};

export function toPlainMessage(message: Message): Message {
  const {
    children: _children,
    parent: _parent,
    siblings: _siblings,
    ...plain
  } = message as MessageWithTreeMetadata;
  return plain;
}
